<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";
  import { parseUrl } from "$lib/utils/helpers.js";

  // Get the block data
  export let blok;
</script>

<section
  class="logo-grid-with-button-section section-header-width mx-auto"
  use:storyblokEditable={blok}
>
  <div class="logo-grid-wrapper">
    <div class="logo-grid">
      {#each blok.logos as logo}
        <img class="logo-image" src={logo.filename} alt={logo.alt} />
      {/each}
    </div>
    <div class="logo-button-wrapper">
      <a href={parseUrl(blok.buttonLink)} class="logo-button scale-up-on-hover"
        >{blok.buttonText} <span class="logo-button-arrow">→</span>
      </a>
    </div>
  </div>
</section>

<style lang="postcss">
  .logo-grid-with-button-section {
    margin-top: 2rem;
    margin-bottom: 3rem;
  }

  .logo-grid-wrapper {
    width: 100%;
    display: grid;
    grid-template-rows: auto auto;
    gap: 2rem;

    @media (min-width: 1400px) {
      grid-template-columns: 1fr;
      align-items: center;
    }

    @media (min-width: 1500px) {
      grid-template-columns: 1fr auto;
    }
  }

  .logo-grid {
    display: flex;
    flex-wrap: wrap;
    column-gap: 1.5rem;
    justify-content: center;

    @media (min-width: 1500px) {
      transform: translateX(-2rem);
    }
  }

  .logo-image {
    width: 150px;
    height: auto;
    object-fit: contain;
    filter: brightness(0) saturate(100%);
    opacity: 0.8;

    @media (min-width: 1500px) {
      width: 145px;
    }
  }

  .logo-button-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .logo-button {
    padding: 12px 15px;
    color: rgb(var(--color-text-dark));
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;

    @hover {
      background-color: rgba(255, 255, 255, 1);
    }
  }

  .logo-button-arrow {
    margin-left: 1rem;
  }
</style>
